/* eslint-disable no-useless-escape, import/no-default-export */
// escapes (adds leading escape slash) every character inside the outer [ ]
// e.g: ? -> \?, } -> \}, ' ' -> \' '

export default (text: string): string =>
  text && text.replace(/[-[\]{}()*+?.,\\\/^$|#\s]/g, '\\$&');
